'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _scriptLoader = require('@spp/script-loader');

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

var _handIcon = require('./hand-icon');

var _handIcon2 = _interopRequireDefault(_handIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LatLonType = _propTypes2.default.shape({
    lat: _propTypes2.default.number.isRequired,
    lon: _propTypes2.default.number.isRequired
});

var MapMapbox = function (_Component) {
    _inherits(MapMapbox, _Component);

    function MapMapbox() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MapMapbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapMapbox.__proto__ || Object.getPrototypeOf(MapMapbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            mapboxgl: null,
            controlsActive: false
        }, _this.mapNode = null, _this.handleActivateControls = function () {
            if (!_this.map) {
                return;
            }

            _this.map.addControl(new _this.state.mapboxgl.NavigationControl());
            _this.map.dragPan.enable();
            _this.map.scrollZoom.enable();
            _this.map.doubleClickZoom.enable();
            _this.map.boxZoom.enable();
            _this.map.touchZoomRotate.enable();

            _this.setState({ controlsActive: true });
        }, _this.renderMap = function () {
            if (!_this.state.mapboxgl) {
                // mapbox script didn't load?
                return;
            }

            _this.state.mapboxgl.accessToken = _this.props.accessToken;

            var _this$props = _this.props,
                location = _this$props.location,
                bounds = _this$props.bounds,
                zoom = _this$props.zoom;


            _this.map = new _this.state.mapboxgl.Map({
                center: [location.lon, location.lat],
                zoom: zoom,
                interactive: false,
                container: _this.mapNode,
                style: 'mapbox://styles/mapbox/streets-v9'
            });

            if (bounds) {
                _this.map.fitBounds([[bounds.sw.lon, bounds.sw.lat], [bounds.ne.lon, bounds.ne.lat]]);
            }

            _this.map.on('load', function () {
                _this.map.loadImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAABbCAYAAAAcNvmZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABh9JREFUeNrsnY1x4joQgGUqyKvgfEMDpAJIBQcVBCogqSChggsVwFUQroJABbgBT5wKHh28Z4XNxEe0knYl/+m0Mx4yN5yt/bTeH2GthYgSJURJujy4XIhU/HnopPg4hufPCFsD9qr8mJTHuDxG8LeL7MsjK4+D/LucgNNfDRssd1oetwC4TpHgf5XHri3LT1qyYAl42QBgHfg1gD8FBxsg3wHkq454rxNAf2oCetIDyBlAORi+N4bzj7oKPakZ9Lz8+EmAXEBgk2Cz4Rk057ojgD6GQJsSoN+X1932BjYEvo1lRiEB72Tw4sK1hH8LscIGvJzwhe9AmtSgmHQZDxbWLBVaD8+gmwzQH8F5YmHlq3J8T52DDb55A9ajky0o0WrhAXefNIq54as7sPJTJ2DDwJ8NwWkPkPcdq1InAH1iCNIzVwNJPAxWAn7RuI1ag06DwVzqceMSV5KaQe/BIk6iBwKu8Flj5U7ABzWCli7jpi+gpcixyjHLsSNfkbq+5MzKN6kB9AkCyk70WCBr2Wh0JFt4whiEDIZHn4PoMHCTUV1TguaAePEPnxY8aHArUpcboXaF7yxywhJEQoT9jOTRtYGulN7yjvqmqAClZb3BZ1bjGDALlyuHM6+woTL8WTfoyhLsD4sCSVeI/BYel1ANwO9tKs3E8kI6Pz3zEQxBmaVFRUeVLSwLZB7GOAU3yvLftj4bi8orV9ByIvOzxRxrAC3gnMf8nLKlLicCXVeI/944WzZUVqoT7SEndQH9CKVykyIN5NFx3C9I4bPQVcqJhf98VVi1vG2+c/0huIyNaPdnsYXDejmLi8mN3GkCAhf0FAJNW6AFXPslZwZg0P0ecSd3ZMvWzB7bfWhcUpuy4C6SIe4Ete4Bw6pXAYF+D/45PzCvKNadEK16W87YwmPK1CVhpbD52YDmNtaNWfbUl1VXgmHXZcNczcOse2rrRpZIqldwlBDdeU5EJ1ccoxh+PhFgZDhAqkXVDK+ZefRI9EdGOS8HXyPnSk2WrUqHCqo/q/yg2jd5oFaawKYwsVTBvkUWdjjuo6/CGfvOxDJRZCH/Kv7TNaXagkBzFP0WXzr/85GVXFr2BHEh1LJ2KfovS6IryRBXMsHcyFiVhTDWDeYBwJ7n9CxKxWqMwVZlDgfiBaciHKHqckDWYYStG6G6kB8BwabqkuncSHKRqr0qfBH1d8r/AoLtS39ZuhdVy05drTrvVwFTl04qZumlG1HBpq5ZBwebodOJC5saHNMAYVN1OtjA9iHfAoTtTadBy1YQomU3BjtKhB1hR9iOUgTIqOgq7LcAYb/VAVs1g+No2WSdxtg5TLCpS4xZgLCpOl1xYZNK1WGAsBk6jYywsccUGAsxu4BYU3/kHiETVqgC5N7VusX5if9Q5LcHq95j2UjmIUj+tZaNsMow2KoVqwnRx8klxm0AoLeMx6JVrA4YbJUbSRl+ex0AbJIO+eeONjs3AjOpciW3jAi+7zHoPSMLUTHKqneHqoL8pfg3zi/mix7D5ox9amI5sAwKKXVLBKQ7qx6CJjeeyfF2SH+wxB6GPyrSGNb2DuRcna0WSx2vGTqqtnt8OdeAEBwmzH2E8pbsQxuMk+DtqkiRLOQLw4Emv1QBIj8CDIGmD/6bu1XvAZm4nRXs4WdTwUuZ54yGtPD88qLjoDn7aSSLucqqqbvFnnxZNwDfdhT4wqF/FWbVyqYBA0MliPnuuQPwWUd8uBzDzGEP5Bzz1VjlGbdT88bvfzu1Ydswe1/j8DMtaiMPl3n0tePaO9ZNSLvN3LbfCNaFwEeHg1TY9211KsGFh/6qmk4SxjokNnehV4rs5i6xbRHNGOpvW1S5YGzIpZhY7w25KlaH9QoJrtWcBehMELpyxiaKfND1NlGEtE2eXNdYkN2hpmOgpwbQN9TMhvX4mWUnx8ceg34UNXTmjC2dv8ak7rV0trBwAYN+zXuw4xfG+FoXaGfLvgiasQ1/E7Art2B8wUQTsC8qzfjqlCZgMxaXChFfCuQt6MTXXTUBu+LL44vcRHxFYVivKESgx5dvtpR+xdfKtmTxExFfmNyq5VcPUybzfgzD3CIYhSL/CzAAScpOq7+Ba/IAAAAASUVORK5CYII=', function (err, image) {
                    if (err) {
                        throw err;
                    }

                    _this.map.addImage('red-dot', image);
                    _this.map.addLayer({
                        id: 'points',
                        type: 'symbol',
                        source: {
                            type: 'geojson',
                            data: {
                                type: 'FeatureCollection',
                                features: [{
                                    type: 'Feature',
                                    geometry: {
                                        type: 'Point',
                                        coordinates: [location.lon, location.lat]
                                    }
                                }]
                            }
                        },
                        layout: {
                            'icon-image': 'red-dot',
                            'icon-size': 0.4
                        }
                    });
                });
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MapMapbox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            (0, _scriptLoader2.default)('https://api.tiles.mapbox.com/mapbox-gl-js/v0.44.2/mapbox-gl.js').then(function () {
                _this2.setState({ mapboxgl: global.mapboxgl }, _this2.renderMap);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.map) {
                this.map.remove();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var theme = this.props.theme;
            var controlsActive = this.state.controlsActive;


            return _react2.default.createElement(
                'div',
                { className: theme.map },
                _react2.default.createElement('div', {
                    className: (0, _classnames3.default)('mapboxgl-map', theme['mapbox-root'], _defineProperty({}, theme['mapbox-active'], controlsActive)),
                    'data-test-tag': '@vg/ui-map-mapbox',
                    ref: function ref(node) {
                        _this3.mapNode = node;
                    }
                }),
                controlsActive ? null : _react2.default.createElement(
                    'div',
                    { className: 'mapboxgl-ctrl-top-right mapboxgl-ctrl' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mapboxgl-ctrl mapboxgl-ctrl-group' },
                        _react2.default.createElement(
                            'button',
                            {
                                onClick: this.handleActivateControls,
                                className: (0, _classnames3.default)('mapboxgl-ctrl-icon', theme['activate-controls-button'])
                            },
                            _react2.default.createElement('img', { src: _handIcon2.default, alt: 'Klikk' }),
                            'Klikk for \xE5 aktivere kartet'
                        )
                    )
                )
            );
        }
    }]);

    return MapMapbox;
}(_react.Component);

MapMapbox.propTypes = {
    accessToken: _propTypes2.default.string.isRequired,

    location: LatLonType.isRequired,

    bounds: _propTypes2.default.shape({
        sw: LatLonType,
        ne: LatLonType
    }),

    theme: _propTypes2.default.shape({
        map: _propTypes2.default.string
    }),

    zoom: _propTypes2.default.number
};
MapMapbox.defaultProps = {
    theme: {},
    zoom: 1,
    bounds: null
};
exports.default = MapMapbox;
//# sourceMappingURL=MapMapbox.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/map-mapbox/lib/cjs/MapMapbox.js
 ** module id = 731
 ** module chunks = 1
 **/